/*
 * Mardo — sold-out products always come after the last in-stock one, whatever
 * sort the shopper picked.
 *
 * Shopify cannot express this natively: every built-in sort interleaves
 * availability, and a MANUAL order can only ever fix the default sort. What
 * Shopify does do well is filter by availability on the server while keeping the
 * chosen sort, so the grid is assembled from two native streams played back to
 * back:
 *
 *   stream A   filter.v.availability=1   everything purchasable, in the chosen sort
 *   stream B   filter.v.availability=0   the rest, in that same sort
 *
 * Stream A rides the theme's own "Load more": its next-page URL already carries
 * both the filter and the sort, so pagination inside A needs no help. This file
 * only swaps the grid over to A after each render, then plays B once A runs out.
 *
 * Two deliberate behaviours:
 *  - If the shopper picks an availability filter themselves, this stands down
 *    completely and the theme behaves natively.
 *  - Products whose variants are mixed (one sold out, one in stock) are
 *    purchasable, so they belong to stream A. Stream B repeats them; they are
 *    deduped by handle and stay where stream A put them.
 *
 * The CSS counterpart in main-collection-product-grid.liquid gives sold-out
 * cards `order: 1`, which keeps them last during the brief moment before this
 * script has swapped in stream A — that is what prevents a flash of interleaved
 * products.
 */
if (!window.__mardoOosLast) {
  window.__mardoOosLast = true;

  var AVAIL = 'filter.v.availability';
  var state = { seen: null, sid: null, bPage: 0, bDone: false, busy: false, swapped: false };

  function grid() { return document.getElementById('items-grid'); }
  function btnBox() { return document.querySelector('[id^="btn-pagination-"]'); }

  // The theme's own next-page control. Only <button> counts: the box also holds
  // a hidden "Next" anchor that is present even when there is no next page.
  function nextButton() {
    var box = btnBox();
    return box ? box.querySelector('button:not([data-mardo-more])') : null;
  }

  // Where our own Load more goes. When the purchasable stream fits on a single
  // page the theme renders no pagination box at all, so one is created after the
  // grid — otherwise the sold-out stream would have nothing to hang off and
  // those products would never be reachable.
  function ownBox() {
    var box = btnBox();
    if (box) return box;
    var g = grid();
    if (!g || !g.parentNode) return null;
    var made = document.getElementById('mardo-more-box');
    if (!made) {
      made = document.createElement('div');
      made.id = 'mardo-more-box';
      made.className = 'text-center mt-10';
      g.parentNode.insertBefore(made, g.nextSibling);
    }
    return made;
  }

  // Resolved once per render and cached, because the pagination box it is
  // usually read from vanishes as soon as the purchasable stream turns out to
  // fit on a single page — and the page's first shopify-section is the header,
  // not the grid, so a late lookup would request the wrong section entirely.
  function resolveSectionId() {
    var b = btnBox();
    if (b) return b.id.replace('btn-pagination-', '');
    var g = grid();
    var sec = g && g.closest ? g.closest('[id^="shopify-section-"]') : null;
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }
  function sectionId() { return state.sid; }

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // The shopper's own In stock / Out of stock choice wins over ours.
  function shopperChoseAvailability() {
    var form = document.getElementById('FacetFiltersForm');
    if (!form) return false;
    var inputs = form.querySelectorAll('input[name="' + AVAIL + '"]');
    for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return true;
    return false;
  }

  // Current facet/sort state, minus any availability value, so we can pin our own.
  function baseParams() {
    var p = new URLSearchParams(window.location.search);
    p.delete(AVAIL);
    p.delete('page');
    p.delete('section_id');
    return p;
  }

  function sectionUrl(availability, page) {
    var sid = sectionId();
    if (!sid) return null;
    var p = baseParams();
    p.set('section_id', sid);
    p.set(AVAIL, String(availability));
    if (page > 1) p.set('page', String(page));
    return window.location.pathname + '?' + p.toString();
  }

  function fetchSection(url) {
    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); });
  }

  function rememberShown() {
    var g = grid();
    if (!g) return;
    var cards = g.querySelectorAll('.grid-item');
    for (var i = 0; i < cards.length; i++) {
      var h = handleOf(cards[i]);
      if (h) state.seen.add(h);
    }
  }

  // Stream A: replace the server-rendered (interleaved) grid with the purchasable
  // stream. The theme's own Load more then walks the rest of A by itself.
  function swapToStreamA() {
    var url = sectionUrl(1, 1);
    var container = document.getElementById('ProductGridContainer');
    if (!url || !container) return Promise.resolve();
    return fetchSection(url).then(function (doc) {
      var fresh = doc.getElementById('ProductGridContainer');
      if (!fresh) return;
      // A collection whose products are ALL sold out returns the "no products
      // found" state for the purchasable stream, with no grid in it. Swapping
      // that in would blank a collection that does have products, so the
      // server-rendered grid is left exactly as it is — every card in it is sold
      // out anyway, which is already the order we want.
      if (!fresh.querySelector('#items-grid')) { rememberShown(); return; }
      container.innerHTML = fresh.innerHTML;
      state.swapped = true;
      rememberShown();
      watchForEndOfStreamA();
      // A purchasable stream that fits on one page never produces a next button,
      // so nothing would ever signal that it is finished — start the sold-out
      // stream right away instead of waiting for a signal that cannot come.
      if (!nextButton()) loadStreamB();
    }).catch(function () { /* leave the native grid in place */ });
  }

  // Stream B: everything that is not purchasable, in the same sort, appended after
  // stream A. Paged behind our own button so nothing is fetched until asked for.
  function loadStreamB() {
    if (state.busy || state.bDone) return;
    state.busy = true;
    var next = state.bPage + 1;
    var url = sectionUrl(0, next);
    var g = grid();
    if (!url || !g) { state.busy = false; return; }

    fetchSection(url).then(function (doc) {
      var incoming = doc.querySelectorAll('#items-grid .grid-item');
      var added = 0;
      for (var i = 0; i < incoming.length; i++) {
        var card = incoming[i];
        var h = handleOf(card);
        if (h && state.seen.has(h)) continue;      // already shown by stream A
        if (h) state.seen.add(h);
        card.setAttribute('data-mardo-oos', '');
        g.appendChild(card);
        added++;
      }
      state.bPage = next;
      // Shopify still renders a next-page button while pages remain.
      var more = doc.querySelector('[id^="btn-pagination-"] button, [id^="btn-pagination-"] a');
      if (!more && added === 0) state.bDone = true;
      if (!more) state.bDone = true;
      renderStreamBButton();
    }).catch(function () {
      state.bDone = true;
      renderStreamBButton();
    }).then(function () { state.busy = false; });
  }

  function renderStreamBButton() {
    var box = ownBox();
    if (!box) return;
    if (state.bDone) { box.innerHTML = ''; return; }
    if (box.querySelector('[data-mardo-more]')) return;
    var wrap = document.createElement('div');
    wrap.className = 'text-center mt-10';
    var btn = document.createElement('button');
    btn.setAttribute('data-mardo-more', '');
    btn.className = 'button button-outline relative pl-9 pr-9 pt-3.5 pb-3.5';
    btn.textContent = box.getAttribute('data-mardo-label') || 'Load more';
    btn.addEventListener('click', function () { loadStreamB(); });
    wrap.appendChild(btn);
    box.innerHTML = '';
    box.appendChild(wrap);
  }

  // Stream A is finished the moment the theme stops rendering a next-page button.
  function watchForEndOfStreamA() {
    var box = btnBox();
    if (!box) return;
    if (box.__mardoWatched) return;
    box.__mardoWatched = true;

    var check = function () {
      if (state.bPage > 0 || state.busy) return;
      if (!nextButton() && !box.querySelector('[data-mardo-more]')) loadStreamB();
    };
    new MutationObserver(check).observe(box, { childList: true, subtree: true });
    // A collection that fits on one page never mutates the button box.
    setTimeout(check, 400);
  }

  function start() {
    if (window.Shopify && window.Shopify.designMode) return;   // theme editor
    state.sid = resolveSectionId();
    if (!grid() || !state.sid) return;
    state.seen = new Set();
    state.bPage = 0;
    state.bDone = false;
    state.busy = false;
    state.swapped = false;
    if (shopperChoseAvailability()) { rememberShown(); return; }
    swapToStreamA();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Every sort/filter change re-renders the grid from scratch — start over.
  document.addEventListener('eurus:collection:reloaded', function () { setTimeout(start, 0); });
}
